export enum EVM_ERROR {
    ASSET_NOT_SUPPORTED = "RENJS:ASSET_NOT_SUPPORTED",
    NETWORK_ERROR = "RENJS:NETWORK_ERROR",
}
